export class DealerClaimSummaryRequest {
  //#region : Constructor :
  constructor(userName?: string, agentCode?: string, dealerCode?: string, summaryDate?: Date, useSefi?: boolean) {
    this.userName = userName;
    this.agentCode = agentCode;
    this.dealerCode = dealerCode;
    this.summaryDate = summaryDate;
    this.useSefi = useSefi;
  }
  //#endregion

  //#region : Properties :
  public userName: string;
  public agentCode: string;
  public dealerCode: string;
  public summaryDate: Date;
  public useSefi: boolean;
  //#endregion
}
